/**
 * trackEvent — un événement Amplitude décrit comme une donnée : son type, et ses propriétés quand il
 * en a. Le type est un nom fixe ; ce qui varie (un libellé, un titre, une étape) va en propriété
 * (`docs/playbook/06-run/run.md`, P-4823).
 */
import * as amplitude from "@amplitude/analytics-react-native"

export type TrackedEvent = {
    name: string
    properties?: Record<string, string>
}

export function track({ name, properties }: TrackedEvent): void {
    if (properties) amplitude.track(name, properties)
    else amplitude.track(name)
}
